import { IsNotEmpty } from "class-validator";

export class CustomerWorkoutSessionCreateSetFormData {
    @IsNotEmpty()
    sessionID: number;

    @IsNotEmpty()
    sessionDate: string;
    
}
